module.exports = __webpack_public_path__ + "static/media/whatsapp.67bb1cc0.png";